import FileIcon from './FileIcon.svg';
import UploadIcon from './UploadIcon.svg';
import PlusIcon from './PlusIcon.svg';
import ScanIcon from './ScanIcon.png';
import PdfIcon from './PdfIcon.svg';

export default {
  FileIcon,
  UploadIcon,
  PdfIcon,
  ScanIcon,
  PlusIcon,
};
